__turbopack_context__.v({
  "button": "SocialShareBlock-module-scss-module__oYbB4W__button",
  "icon": "SocialShareBlock-module-scss-module__oYbB4W__icon",
  "rounded": "SocialShareBlock-module-scss-module__oYbB4W__rounded",
});
